module.exports = __webpack_public_path__ + "img/edit.0202df7d.svg";